import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { Config } from 'src/app/models/configuration.model';
import { ContentService } from 'src/app/services/content.service';
import { CursorService } from 'src/app/services/cursor.service';
import { MultimodalService } from 'src/app/services/multimodal.service';
import { VoiceControlService } from 'src/app/services/voice-control.service';


@Component({
  selector: 'app-publications',
  templateUrl: './publications.component.html',
  styleUrls: ['./publications.component.css']
})
export class PublicationsComponent implements OnInit {

  publications = [];
  allPublications = [];
  searchInput: string = null;
  sortDirection = 'down';
  sortBy = 'citations';


  imageVisible = false;

  headerStuck = false;
  width: number;
  voiceSearch = false;

  public config: Config;
  months = [ { month: "Jan", index: 1 }, { month: "Feb", index: 2 }, { month: "Mar", index: 3 }, { month: "Apr", index: 4 }, { month: "May", index: 5 },
             { month: "June", index: 6 }, { month: "July", index: 7 }, { month: "Aug", index: 8 }, { month: "Sept", index: 9 }, { month: "Oct", index: 10 },
             { month: "Nov", index: 11 }, { month: "Dec", index: 12 } ];

  publicationTypes = [
    { id: 0, name: "All", searchSlug: ["all"], active: true },
    { id: 1, name: "Conference Papers", searchSlug: ["conference paper"], active: false },
    { id: 2, name: "Book Chapters & Journal Articles", searchSlug: ["journal", "book chapter"], active: false },
    { id: 3, name: "Magazine Articles", searchSlug: ["magazine article"], active: false },
    { id: 4, name: "Workshops", searchSlug: ["workshop"], active: false },
    { id: 5, name: "Thesis", searchSlug: ["thesis"], active: false }
  ];

  constructor(@Inject(DOCUMENT) private document: Document, private contentService: ContentService, private cursorService: CursorService,
    private multimodalService: MultimodalService, private voiceControlService: VoiceControlService) {
      this.config = this.multimodalService.config;
      this.width = window.innerWidth;
      this.multimodalService.config.activePage = 'publications';

      this.voiceControlService.selectPublications.subscribe(res => {
        let i = 0;
        for (const type of this.publicationTypes) {
          if (type.searchSlug.indexOf(res) > -1) {
            // this.sortByPublicationType(type);
            this.document.getElementById('publication-type-' + i).click();
            break;
          }
          i++;
        }
      });

      this.voiceControlService.sortPublications.subscribe(res => {
        this.config.inputActive = false;
        this.config.inputFocus = false;
        this.document.getElementById('sort-' + res).click();
      });

      this.voiceControlService.searchInput.subscribe(res => {
        this.voiceSearch = true;
        this.config.inputActive = true;
        (this.document.getElementById('search-input') as HTMLInputElement).style.opacity = "1";
        (this.document.getElementById('search-input') as HTMLInputElement).value = res;
        this.searchPublications();
      });

      this.voiceControlService.closeSearch.subscribe(res => {
        this.document.getElementById('search-button').click();
      });

      this.voiceControlService.changeSortDirectionPublicationList.subscribe(res => {
        this.document.getElementById('sortButton').click();
      });


  }

  openPublication(url: string) {
    if (url) {
      this.multimodalService.playAudioClick();
      this.multimodalService.playHapticButtonClick(200);
      setTimeout(() => window.open(url, '_blank'), 500);
    }
  }

  toggleInputField() {
    this.config.inputActive = !this.config.inputActive;
    this.multimodalService.playAudioClick();
    this.multimodalService.playHapticButtonClick(200);
    if (this.config.inputActive && window.innerWidth > 1400) {
      this.document.getElementById('search-input').focus();
    } else if (!this.config.inputActive && window.innerWidth > 1400) {
      this.document.getElementById('publication-type-0').classList.add('active');
      this.document.getElementById('publication-type-0').click();
    } else {
      this.searchPublications();
    }
  }

  ngOnInit() {
    window.scrollTo(0,0);
    let customPublicationList = [];
    this.contentService.getPublications().subscribe(res => {
      customPublicationList = res;
    });

    this.contentService.getScholarPublications().subscribe(res => {

      this.allPublications = res;

      for (const el of this.allPublications) {

        if (el.data?.conference?.toLowerCase().includes('workshop') || el.data?.book?.toLowerCase().includes('workshop') || el.data?.journal?.toLowerCase().includes('workshop')) {
          el.type = 'workshop';
        } else if (!el.data?.volume && (el.data?.conference || this.checkInput(el.data?.book, ['conference', 'symposium', 'proceedings', 'extended abstract']) || this.checkInput(el.data?.journal, ['conference', 'symposium', 'proceedings', 'extended abstract']))) {
          el.type = 'conference paper';
        } else if (!this.checkInput(el.data?.journal, ['journal', 'book', 'computer', 'psychophysiology', 'ieee']) && el.data?.volume && el.data?.issue) {
          el.type = 'magazine article';
        } else if ((this.checkInput(el.data?.book, ['book']) || this.checkInput(el.data?.journal, ['book'])) && el.data?.pages && !el.data?.volume) {
          el.type = 'book chapter';
        } else if ((el.data?.publisher || el.data?.journal) && el.data?.pages) {
          el.type = 'journal';
        }
      }
      for (const el of customPublicationList) {
        const publication = this.allPublications.filter(p => p.title.toLowerCase() === el.title.toLowerCase() && p.data?.year.toString() === el.data?.year.toString())[0];
        if (publication) {
          if (el.type) { publication.type = el.type; }
          if (el.data?.authors) { publication.data.authors = el.data?.authors; }
          if (el.data?.conference) { publication.data.conference = el.data?.conference; }
          if (el.data?.journal) { publication.data.journal = el.data?.journal; }
          if (el.data?.book) { publication.data.book = el.data?.book; }
          if (el.data?.volume) { publication.data.volume = el.data?.volume; }
          if (el.data?.issue) { publication.data.issue = el.data?.issue; }
          if (el.data?.publication_date) { publication.data.publication_date = el.data?.publication_date; }
          if (el.data?.pdf?.host) { publication.pdf.host = el.data?.pdf?.host; }
          if (el.data?.pdf?.link) { publication.pdf.link = el.data?.pdf?.link; }
          if (el.image) { publication.image = el.image }
        } else {
          this.allPublications.push(el);
        }
      }
      this.publications = this.allPublications;
      this.orderByColumn('citations', true);
    });

  }



  checkInput(input: string, words: Array<string>) {
    if (input) {
      return words.some(word => input.toLowerCase().includes(word.toLowerCase()));
    }
    return false;
   }


  @HostListener('document:mousemove', ['$event']) onMouseMove(e: any) {

    if (this.config.modalities[1].active && this.imageVisible) {
      this.cursorService.moveImage(e.pageX, e.pageY - window.pageYOffset);
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = window.innerWidth;
  }

  showImagePreview(url: string) {
    if (this.config.modalities[1].active && url) {
      this.document.getElementById('image-cursor').style.backgroundImage = 'url(/assets/images/publication-images/' + url + ')';
      this.document.getElementById('image-cursor').style.opacity = '0.8';
      this.imageVisible = true;
    }
  }

  hideImagePreview() {
    this.document.getElementById('image-cursor').style.backgroundImage = 'none';
    this.document.getElementById('image-cursor').style.opacity = '0';
    this.imageVisible = false;
  }

  showSearchInput() {
    this.multimodalService.playAudioClick();
    this.multimodalService.playHapticButtonClick(200);
    this.document.getElementById('search-input').classList.add('visible');
  }

  focusInput() {
    this.config.inputFocus = true;
    this.multimodalService.playAudioClick();
    this.multimodalService.playHapticButtonClick(100);
  }

  sortByPublicationType(type: any, feedback = true) {
    if (feedback) {
      this.multimodalService.playAudioSlideClick();
      this.multimodalService.playHapticButtonClick([100, 70, 100]);
    }

    for(const el of this.publicationTypes) {
      if (el.name === type.name) {
        el.active = true;
      } else {
        el.active = false;
      }
    }
    if (type.name.toLowerCase() === 'all') {
      this.publications = this.allPublications;
    } else {
      this.publications = [];
      for(const publication of this.allPublications) {
        if (type.searchSlug.filter(s => s === publication.type).length > 0) {
          this.publications.push(publication);

        }
      }
    }
  }

  changeCursorBlendMode(hover: boolean) {
    if (hover) {
      this.document.getElementById('cursor').classList.add('normal');
    } else {
      this.document.getElementById('cursor').classList.remove('normal');
    }
  }

  orderByColumn(type: string, first = false) {

    if (!first && this.sortBy === type) {
      this.changeSortDirection();
    } else {
      if (!first) {
        this.multimodalService.playAudioSlideClick();
        this.multimodalService.playHapticButtonClick(100);
      }
      this.sortBy = type;
      if (this.sortBy === 'title') {
        this.publications.sort((a, b) => {
          if (a.title < b.title) {
            return -1;
          }
          if (a.title > b.title) {
            return 1;
          }
          return 0;
        });

      } else if (this.sortBy === 'date') {

        this.publications.sort((a, b) => {
          if (a.publication_date && b.publication_date) {
            const month_a = a.publication_date.split(' ');
            const month_b = b.publication_date.split(' ');
            const a_index = this.months.filter(m => m.month === month_a[0])[0].index;
            const b_index = this.months.filter(m => m.month === month_b[0])[0].index;
            if (a_index && b_index) {
              if (a_index < b_index) {
                return this.sortDirection === 'up' ? -1 : 1;
              }
              if (a_index < b_index) {
                return this.sortDirection === 'up' ? 1 : -1;
              }
            }
          }
          return 0;
        });

        this.publications.sort((a, b) => {
          if (a.publication_date && b.publication_date) {
            const day_a = a.publication_date.split(' ');
            const day_b = b.publication_date.split(' ');
            if (day_a.length > 1 && day_b.length > 1) {
              if (day_a[1] < day_b[1]) {
                return this.sortDirection === 'up' ? -1 : 1;
              }
              if (day_a[0] < day_b[0]) {
                return this.sortDirection === 'up' ? 1 : -1;
              }
            }
          }
          return 0;
        });

        this.publications.sort((a, b) => {
          if (a.data.year < b.data.year) {
            return this.sortDirection === 'up' ? -1 : 1;
          }
          if (a.data.year > b.data.year) {
            return this.sortDirection === 'up' ? 1 : -1;
          }
          return 0;
        });

      } else if (this.sortBy === 'citations') {
        this.publications.sort((a, b) => {
          if (a.data.citations?.total && b.data.citations?.total) {
            if (parseInt(a.data.citations.total) < parseInt(b.data.citations.total)) {
              return this.sortDirection === 'up' ? -1 : 1;
            }
            if (parseInt(a.data.citations.total) > parseInt(b.data.citations.total)) {
              return this.sortDirection === 'up' ? 1 : -1;
            }
          }
          return 0;
        });
      }
    }
  }

  changeSortDirection() {
    this.multimodalService.playAudioSlideClick();
    this.multimodalService.playHapticButtonClick(100);
    this.sortDirection = this.sortDirection === 'down' ? 'up' : 'down';
    this.publications.reverse();
  }


  searchPublications() {
    this.searchInput = (this.document.getElementById('search-input') as HTMLInputElement).value;
    const searchArray = this.searchInput.split(' ');
 
    this.publications = [];

    for (const item of searchArray) {
      if (item && this.voiceControlService.commonSearchWords.indexOf(item.toLowerCase()) > -1) {
        for (const publication of this.allPublications) {
          let added = false;
          if (publication?.title.toLowerCase().includes(item.toLowerCase()) ||
              publication?.data?.year?.toString().includes(item.toLowerCase()) ||
              publication?.data?.description?.toLowerCase().includes(item.toLowerCase())) {

            added = true;
            this.addPublication(publication);
          }
          if (!added && publication?.data?.authors?.length > 0) {
            for (const author of publication?.data?.authors) {
              if (author?.toLowerCase().includes(item.toLowerCase())) {
                added = true;
                this.addPublication(publication);
                break;
              }
            }
          }
          if (!added && publication.data?.conference) {
            if (publication?.data?.conference?.toLowerCase().includes(item.toLowerCase())) {
              added = true;
              this.addPublication(publication);
            }
          }
          if (!added && publication.data?.book) {
            if (publication?.data?.book?.toLowerCase().includes(item.toLowerCase())) {
              added = true;
              this.addPublication(publication);
            }
          }
          if (!added && publication.data?.publisher) {
            if (publication?.data?.publisher?.toLowerCase().includes(item.toLowerCase())) {
              added = true;
              this.addPublication(publication);
            }
          }
          if (!added && publication.data?.journal) {
            if (publication?.data?.journal.toLowerCase().includes(item.toLowerCase())) {
              added = true;
              this.addPublication(publication);
            }
          }
          if (!added && publication.type) {
            if (publication?.type.toLowerCase().includes(item.toLowerCase())) {
              added = true;
              this.addPublication(publication);
            }
          }
        }
      }
    }

    if (this.voiceSearch) {
      this.voiceSearch = false;
      let reply = "I have found " + this.publications.length + " items that match your search.";
      if (this.publications.length === 1) {
        reply = "I have found one item that matches your search.";
      } else if (this.publications.length === 0) {
        reply = "Sorry, I didn't find any items.";
      }
      this.voiceControlService.respond(reply);
    }
    this.hideImagePreview();
  }

  addPublication(publication: any) {
    if (this.publications.filter(p => p.title === publication?.title).length === 0) {
      this.publications.push(publication);
    }
  }


}
